import React, { useEffect, useState } from 'react';
import Select from 'components/Select';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { thunkFetchEventLeaderboards } from '@/redux/actions/leaderboard.action';

const LeaderboardPicker = ({
	handlePickItem,
	fetchEventLeaderboards,
	leaderboards,
	leaderboard,
}) => {
	const { eventID } = useParams();
	const [selectedLeaderboard, setSelectedLeaderboard] = useState({});

	const handleSetLeaderboardRoute = sessionId => {
		if (leaderboards) {
			const leaderboard = leaderboards.find(l => Number(l.id) === Number(sessionId));
			handlePickItem({
				route: `/leaderboard/${sessionId}`,
				name: leaderboard ? leaderboard.name : 'Leaderboard',
			});
		}
	};
	useEffect(() => {
		fetchEventLeaderboards(eventID, 'Omnipicker');
	}, [eventID]);

	useEffect(() => {
		if (leaderboard && leaderboard.includes('leaderboard')) {
			const leaderboardKey = leaderboard.split('/');
			const leaderboardID = +leaderboardKey[leaderboardKey.length - 1];
			setSelectedLeaderboard([leaderboardID]);
		}
	}, [leaderboard]);

	if (!leaderboards) return null;

	return (
		<div>
			<Select
				data={leaderboards}
				value={selectedLeaderboard || {}}
				placeholder="Select a Leaderboard"
				onChange={handleSetLeaderboardRoute}
			/>
		</div>
	);
};

const msp = state => ({
	leaderboards: Object.values(state.leaderboards),
});

const mdp = dispatch => ({
	fetchEventLeaderboards: (eventID, from) => dispatch(thunkFetchEventLeaderboards(eventID, from)),
});

export default connect(msp, mdp)(LeaderboardPicker);
